import React from 'react';

export const RocketIcon: React.FC = () => {
  return (
    <svg width="41" height="30" viewBox="0 0 41 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.8">
        <path
          d="M32.5095 9.75C32.5095 13.685 29.3195 16.875 25.3845 16.875C21.4495 16.875 18.2595 13.685 18.2595 9.75C18.2595 5.81497 21.4495 2.625 25.3845 2.625C29.3195 2.625 32.5095 5.81497 32.5095 9.75Z"
          fill="#FF576D"
        />
        <path
          d="M37.0096 25.125C37.6309 25.125 38.1398 24.6204 38.085 24.0014C37.971 22.7122 37.6611 21.4456 37.1641 20.2458C36.5233 18.6989 35.5842 17.2933 34.4002 16.1094C33.2163 14.9254 31.8107 13.9863 30.2638 13.3455C28.7169 12.7048 27.059 12.375 25.3846 12.375C23.7103 12.375 22.0523 12.7048 20.5054 13.3455C18.9585 13.9863 17.553 14.9254 16.369 16.1094C15.1851 17.2933 14.2459 18.6989 13.6052 20.2458C13.1082 21.4456 12.7983 22.7122 12.6842 24.0014C12.6295 24.6204 13.1383 25.125 13.7596 25.125L37.0096 25.125Z"
          fill="#FB9C4E"
        />
        <path
          d="M31.2458 13.8021C29.9598 15.6589 27.8142 16.875 25.3845 16.875C22.9549 16.875 20.8093 15.6589 19.5232 13.8021C19.8434 13.6364 20.1711 13.484 20.5053 13.3455C22.0522 12.7048 23.7102 12.375 25.3845 12.375C27.0589 12.375 28.7168 12.7048 30.2637 13.3455C30.598 13.484 30.9256 13.6364 31.2458 13.8021Z"
          fill="#E4364D"
        />
      </g>
      <path
        d="M22.125 9.75C22.125 13.685 18.935 16.875 15 16.875C11.065 16.875 7.875 13.685 7.875 9.75C7.875 5.81497 11.065 2.625 15 2.625C18.935 2.625 22.125 5.81497 22.125 9.75Z"
        fill="#FF576D"
      />
      <path
        d="M26.6251 25.125C27.2464 25.125 27.7552 24.6204 27.7005 24.0014C27.5864 22.7122 27.2765 21.4456 26.7796 20.2458C26.1388 18.6989 25.1997 17.2933 24.0157 16.1094C22.8318 14.9254 21.4262 13.9863 19.8793 13.3455C18.3324 12.7048 16.6744 12.375 15.0001 12.375C13.3257 12.375 11.6678 12.7048 10.1209 13.3455C8.57398 13.9863 7.16843 14.9254 5.98448 16.1094C4.80054 17.2933 3.86138 18.6989 3.22063 20.2458C2.72366 21.4456 2.41375 22.7122 2.2997 24.0014C2.24495 24.6204 2.75378 25.125 3.3751 25.125L26.6251 25.125Z"
        fill="#FB9C4E"
      />
      <path
        d="M20.8613 13.8021C19.5753 15.6589 17.4296 16.875 15 16.875C12.5703 16.875 10.4247 15.6589 9.13867 13.8021C9.4589 13.6364 9.78654 13.484 10.1208 13.3455C11.6677 12.7048 13.3256 12.375 15 12.375C16.6743 12.375 18.3323 12.7048 19.8792 13.3455C20.2134 13.484 20.5411 13.6364 20.8613 13.8021Z"
        fill="#E4364D"
      />
    </svg>
  );
};
